import OnboardingSlide from './OnboardingSlide';
import TabsDemoAnimation from './TabsDemoAnimation';

export default function SlideTabs() {
  return (
    <OnboardingSlide illustration={<TabsDemoAnimation />} title="Session Tabs">
      <p>
        The bottom navigation keeps everything from your shift in one place:
      </p>
      <ul className="list-inside list-disc space-y-1 text-xs">
        <li>
          <strong>Notes</strong> — SOAP progress notes from your recordings.
        </li>
        <li>
          <strong>Vitals</strong> — individual vital entries (e.g. &ldquo;Pain 4/10&rdquo;, &ldquo;BP
          140/90&rdquo;).
        </li>
        <li>
          <strong>Medications</strong> — medication administration records (MAR).
        </li>
        <li>
          <strong>Reports</strong> — shift handovers and other compiled reports.
        </li>
      </ul>
      <p>
        Tap <strong>View</strong> on any entry to open the full detail. From there, tap the download
        icon to <strong>print or save a PDF</strong> for the chart or physician review.
      </p>
      <p className="text-xs text-gray-500">
        Tabs update automatically as you save notes during your shift.
      </p>
    </OnboardingSlide>
  );
}
